import {
  GET_SESSION_TICKETS,
  GET_SESSION_TICKET_FAIL,
  GET_SESSION_TICKETS_SUCCESS,
  GET_SESSION_TICKET_DETAIL,
  ADD_NEW_SESSION_TICKET,
  ADD_SESSION_TICKET_SUCCESS,
  ADD_SESSION_TICKET_FAIL,
  UPDATE_SESSION_TICKET,
  UPDATE_SESSION_TICKET_SUCCESS,
  UPDATE_SESSION_TICKET_FAIL,
  GET_SESSION_TICKET_DETAIL_FAIL,
  GET_SESSION_TICKET_DETAIL_SUCCESS,
  CLEAR_MESSAGE,
  DELETE_SESSION_TICKET,
  DELETE_SESSION_TICKET_SUCCESS,
  DELETE_SESSION_TICKET_FAIL,
  GET_EXPORT_SESSION_TICKETS,
  GET_EXPORT_SESSION_TICKETS_SUCCESS,
  GET_EXPORTED_SESSION_TICKETS_FAIL,
  RESET_EXPORT_DATA,
  MANUAL_LIFTUP_BARRIER_REQ,
  MANUAL_LIFTUP_BARRIER_SUCCESS,
  MANUAL_LIFTUP_BARRIER_FAIL,
} from "./actionTypes"

export const getSessionTickets = payload => ({
  type: GET_SESSION_TICKETS,
  payload,
})

export const getSessionTicketSuccess = SessionTicket => ({
  type: GET_SESSION_TICKETS_SUCCESS,
  payload: SessionTicket,
})

export const addNewSessionTicket = SessionTicket => ({
  type: ADD_NEW_SESSION_TICKET,
  payload: SessionTicket,
})

export const addSessionTicketSuccess = SessionTicket => ({
  type: ADD_SESSION_TICKET_SUCCESS,
  payload: SessionTicket,
})

export const addSessionTicketFail = error => ({
  type: ADD_SESSION_TICKET_FAIL,
  payload: error,
})

export const updateSessionTicket = SessionTicket => ({
  type: UPDATE_SESSION_TICKET,
  payload: SessionTicket,
})

export const updateSessionTicketSuccess = SessionTicket => ({
  type: UPDATE_SESSION_TICKET_SUCCESS,
  payload: SessionTicket,
})

export const updateSessionTicketFail = error => ({
  type: UPDATE_SESSION_TICKET_FAIL,
  payload: error,
})

export const getSessionTicketsFail = error => ({
  type: GET_SESSION_TICKET_FAIL,
  payload: error,
})

export const getSessionTicketDetail = SessionTicketId => ({
  type: GET_SESSION_TICKET_DETAIL,
  SessionTicketId,
})

export const getSessionTicketDetailSuccess = SessionTicketDetails => ({
  type: GET_SESSION_TICKET_DETAIL_SUCCESS,
  payload: SessionTicketDetails,
})

export const getSessionTicketDetailFail = error => ({
  type: GET_SESSION_TICKET_DETAIL_FAIL,
  payload: error,
})

export const clearMessage = () => ({
  type: CLEAR_MESSAGE,
})
export const deleteSessionTicket = SessionTicket => ({
  type: DELETE_SESSION_TICKET,
  payload: SessionTicket,
})

export const deleteSessionTicketSuccess = SessionTicket => ({
  type: DELETE_SESSION_TICKET_SUCCESS,
  payload: SessionTicket,
})

export const deleteSessionTicketFail = error => ({
  type: DELETE_SESSION_TICKET_FAIL,
  payload: error,
})

export const getExportSessionTickets = payload => ({
  type: GET_EXPORT_SESSION_TICKETS,
  payload,
})

export const getExportSessionTicketsSuccess = SessionTicket => ({
  type: GET_EXPORT_SESSION_TICKETS_SUCCESS,
  payload: SessionTicket,
})

export const getExportSessionTicketsFail = error => ({
  type: GET_EXPORTED_SESSION_TICKETS_FAIL,
  payload: error,
})

export const resetExportFileData = () => ({
  type: RESET_EXPORT_DATA,
})

export const postManualLiftupBarrier = payload => ({
  type: MANUAL_LIFTUP_BARRIER_REQ,
  payload,
})

export const postManualLiftupBarrierSuccess = payload => ({
  type: MANUAL_LIFTUP_BARRIER_SUCCESS,
  payload,
})

export const postManualLiftupBarrierFail = error => ({
  type: MANUAL_LIFTUP_BARRIER_FAIL,
  payload: error,
})
